import React, { Component } from 'react';
import App_data from '../../../config/App_data';
import FD from '../../../RestAPI/fetchData';
// import GD from "../../../RestAPI/getData";
import SoaP_SubscriptionCheck from '../../../RestAPI/SoaPSubscription';
import PartnerSoaP_SubscriptionCheck from '../../../RestAPI/PartnerSubscription/SoaPSubscription';
import language from '../../../../assets/languages/language';
import ModalComponent from '../../../Common/Modal';
import AlertMessage from '../../../config/alertMessage';
import PDFModelComponent from '../../../Common/PDFModel';
import { Modal, ModalHeader, ModalBody, Button } from 'reactstrap';
// import { getDeviceDetails } from "../../../../common/deviceDetails";
import { getIpAddress } from '../../../../common/getIpAddress';
import { examNameAccordingToDB } from '../../../../common/constant';
import {autorun} from "mobx";
import userStore from "../../../../store/userStore";
/* eslint-disable*/
class SOA_P_Readings extends Component {
  constructor(props) {
    super(props);
    this.state = {
      alert_status: false,
      PDF_Alert_status: false,
      PDFDownloadAlertStatus: false,

      MessageTitle: `${language.LC().MESSAGE}`,
      MessageContent: `${language.LC().QUESTION_NOT_FOUND}`,
      PDFMessageTitle: App_data.messageTitle_cfa,
      PDFMessageContent: AlertMessage.messageContent_soa_p,
      readings: [],
      token: '',
      idname: '',
      chapterid: this.props.params.chapter,
      chapterName: '',
      ValidToken: false,
      chapter_id: '',
      no_result_display: '',
      subscriptionstatus: '',
      showFreePremium: '',
      selectedmenu: 'soa_p',
      PDFDownloadType: 'Question',
      pdfLoading: true,
      pdfLoadingAnswer: true,
      PDFContentMessage: language.LC().PDFContentMessage,
      type: 'question',
      user_city: '',
      user_country: '',
      user_ip: '',
      user_state: '',
      user_continent: '',
    };
    this.toggleAlert = this.toggleAlert.bind(this);
    this.PDFToggleAlert = this.PDFToggleAlert.bind(this);

    this.pdfAlertModel = this.pdfAlertModel.bind(this);
  }

  toggleAlert() {
    this.setState({
      alert_status: !this.state.alert_status,
    });
  }

  PDFToggleAlert() {
    this.setState({
      PDF_Alert_status: !this.state.PDF_Alert_status,
    });
  }

  pdfAlertModel() {
    this.setState({
      PDFDownloadAlertStatus: !this.state.PDFDownloadAlertStatus,
    });
  }
  //On Page Load,init this method
  async componentDidMount() {
    window.scrollTo(0, 0);
    // api to get ip address
    const result = await getIpAddress();
    if (result) {
      this.setState({
        user_city: result.city,
        user_country: result.country,
        user_ip: result.query,
        user_state: result.region,
        user_continent: result.continent,
      });
    }
    var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
    this.setState({ idname: storage_session['idname'] });
    this.setState({ token: storage_session['token'] });
    if (localStorage.getItem('selectedmenu') === 'frm') {
      this.context.router.push({
        pathname: '/soa/probability/questionbank/',
        state: {
          token: storage_session['token'],
          idname: storage_session['idname'],
        },
      });
    }

    // var data = {
    //   token: storage_session['token'],
    //   idname: storage_session['idname'],
    // };
    // await FD.callAPI(App_data.backend_api + '/user/getProfileInfo', data).then(resp => {
    //   console.log("SSSSSSS:::::::")
    // // this.dispose = autorun(async () => {
    // //   const resp = userStore;
    // //   if(resp == null || resp.profileInfo == null){
    // //     return null;
    // //   }
    //   if (resp.profileInfo.role === 'partner') {
    //     if (resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '') {
    //       this.setState({ showFreePremium: true });
    //     } else {
    //       var data_arr = resp.profileInfo.exam_selected
    //         ? JSON.parse(resp.profileInfo.exam_selected)
    //         : null;
    //       var dataset = {
    //         token: this.state.token,
    //         idname: this.state.idname,
    //         examid: data_arr,
    //       };
    //       FD.callAPI(App_data.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(
    //         async resp_exam => {
    //           if (resp_exam.success) {
    //             var exam_data = resp_exam.examData;
    //             var selectedmen = this.state.selectedmenu;
    //             var isInArray_var = false;
    //             isInArray_var = await PartnerSoaP_SubscriptionCheck.checkSoaP_PDFSubscription(
    //               selectedmen,
    //               exam_data,
    //               this.state.type,
    //             );
    //             if (isInArray_var) {
    //               this.setState({ showFreePremium: false });
    //             } else {
    //               this.setState({ showFreePremium: true });
    //             }
    //           } else {
    //             console.log('fail');
    //           }
    //         },
    //       );
    //     }
    //   } else {
    //     if (resp.profileInfo.exam_selected === '') {
    //       this.setState({ showFreePremium: true });
    //     } else {
    //       var data_arr = resp.profileInfo.exam_selected
    //         ? JSON.parse(resp.profileInfo.exam_selected)
    //         : null;
    //       // console.log("dsarafaygdu", data_arr);
    //
    //       var dataset = {
    //         token: this.state.token,
    //         idname: this.state.idname,
    //         examid: data_arr,
    //       };
    //       FD.callAPI(App_data.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(
    //         resp_exam => {
    //           if (resp_exam.success) {
    //             var exam_data = resp_exam.examData;
    //             var selectedmen = this.state.selectedmenu;
    //             var isInArray_var = false;
    //             isInArray_var = SoaP_SubscriptionCheck.checkSoaP_PDFSubscription(
    //               selectedmen,
    //               exam_data,
    //               this.state.type,
    //             );
    //             if (isInArray_var) {
    //               this.setState({ showFreePremium: false });
    //             } else {
    //               this.setState({ showFreePremium: true });
    //             }
    //           } else {
    //             console.log('fail');
    //           }
    //         },
    //       );
    //     }
    //   }
    // });
    //
    var data = {
      token: storage_session['token'],
      idname: storage_session['idname'],
      chapter: this.state.chapterid,
    };
    FD.callAPI(App_data.backend_api + '/soa_p_question_bank/getReadings', data).then(resp => {
      if (resp.success) {
        // console.log(resp);
        this.setState({ ValidToken: true });
        this.setState({ readings: resp.readings });
        this.setState({ chapterName: resp.chaptername.chapter_name });
        if (!resp.readings.length) {
          this.setState({ no_result_display: 'No Saved Questions' });
        }
      } else {
        this.setState({ ValidToken: false });
      }
      return resp;
    });

    var final_exam = [];
    var data = {
      token: storage_session['token'],
      idname: storage_session['idname'],
    };

    this.dispose = autorun(() => {
      const resp = userStore;
      if(resp == null || resp.profileInfo == null) {
        return;
      }
      // console.log("resp getProfile info", resp);
      if (resp.profileInfo.role === 'partner') {
        if (resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '') {
          this.setState({
            showFreePremium: true,
            subscriptionstatus: 'free',
          });
        } else {
          var data_arr = resp.profileInfo.exam_selected
            ? JSON.parse(resp.profileInfo.exam_selected)
            : null;

          var dataset = {
            token: this.state.token,
            idname: this.state.idname,
            examid: data_arr,
          };
          FD.callAPI(App_data.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(
            async resp_exam => {
              if (resp_exam.success) {
                var exam_data = resp_exam.examData;
                var selectedmen = this.state.selectedmenu;
                var isInArray_var = false;
                isInArray_var = await PartnerSoaP_SubscriptionCheck.checkSoaPSubscription(
                  selectedmen,
                  exam_data,
                );
                if (isInArray_var) {
                  this.setState({ subscriptionstatus: 'paid' });
                } else {
                  this.setState({ subscriptionstatus: 'free' });
                }
              } else {
                console.log('fail');
              }
            },
          );
        }
      } else {
        if (resp.profileInfo.exam_selected === '') {
          this.setState({
            showFreePremium: true,
            subscriptionstatus: 'free',
          });
        } else {
          var data_arr = resp.profileInfo.exam_selected
            ? JSON.parse(resp.profileInfo.exam_selected)
            : null;
          var dataset = {
            token: this.state.token,
            idname: this.state.idname,
            examid: data_arr,
          };
          FD.callAPI(App_data.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(
            resp_exam => {
              // console.log(resp_exam);
              if (resp_exam.success) {
                var exam_data = resp_exam.examData;
                var selectedmen = this.state.selectedmenu;
                var isInArray_var = false;
                isInArray_var = SoaP_SubscriptionCheck.checkSoaPSubscription(
                  selectedmen,
                  exam_data,
                );
                // console.log(isInArray_var);
                if (isInArray_var) {
                  this.setState({ subscriptionstatus: 'paid' });
                } else {
                  this.setState({ subscriptionstatus: 'free' });
                }
              } else {
                console.log('fail');
              }
            },
          );
        }
      }
    });
  }

  //it is use to redirect page
  static contextTypes = {
    router: React.PropTypes.object,
  };

  //Function to redirect page to question bank page
  _getChapters = e => {
    this.context.router.push({
      pathname: '/soa/probability/questionbank',
      state: { token: this.state.token, idname: this.state.idname },
    });
  };

  //Function to redirect page to viewquestions page
  _getQuestions = (reading, e) => {
    var user_data = { token: this.state.token, idname: this.state.idname };
    FD.callAPI(App_data.backend_api + '/user/getProfileInfo', user_data).then(resp => {
      if (resp.profileInfo.role === 'partner') {
        if (resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '') {
          this._runCode('free', reading);
          this.setState({ subscriptionstatus: 'free' });
        } else {
          var subscription_details = resp.profileInfo.subscription_details
            ? JSON.parse(resp.profileInfo.subscription_details)
            : resp.profileInfo.subscription_details;

          this.setState({
            subscription_details: subscription_details,
          });
          var data_arr = resp.profileInfo.exam_selected
            ? JSON.parse(resp.profileInfo.exam_selected)
            : null;
          var dataset = {
            token: this.state.token,
            idname: this.state.idname,
            examid: data_arr,
          };
          FD.callAPI(App_data.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(
            async resp_exam => {
              if (resp_exam.success) {
                var exam_data = resp_exam.examData;
                var selectedmen = this.state.selectedmenu;
                var isInArray_var = false;
                isInArray_var = await PartnerSoaP_SubscriptionCheck.checkSoaPSubscription(
                  selectedmen,
                  exam_data,
                );
                if (isInArray_var) {
                  this._runCode('paid', reading);
                  this.setState({ subscriptionstatus: 'paid' });
                } else {
                  this._runCode('free', reading);
                  this.setState({ subscriptionstatus: 'free' });
                }
              } else {
                console.log('fail');
              }
            },
          );
        }
      } else {
        if (resp.profileInfo.exam_selected === '') {
          this._runCode('free', reading);
          this.setState({ subscriptionstatus: 'free' });
        } else {
          var subscription_details = resp.profileInfo.subscription_details
            ? JSON.parse(resp.profileInfo.subscription_details)
            : resp.profileInfo.subscription_details;

          this.setState({
            subscription_details: subscription_details,
          });
          var data_arr = resp.profileInfo.exam_selected
            ? JSON.parse(resp.profileInfo.exam_selected)
            : null;
          var dataset = {
            token: this.state.token,
            idname: this.state.idname,
            examid: data_arr,
          };
          FD.callAPI(App_data.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(
            resp_exam => {
              if (resp_exam.success) {
                var exam_data = resp_exam.examData;
                var selectedmen = this.state.selectedmenu;
                var isInArray_var = false;
                isInArray_var = SoaP_SubscriptionCheck.checkSoaPSubscription(
                  selectedmen,
                  exam_data,
                );
                if (isInArray_var) {
                  this._runCode('paid', reading);
                  this.setState({ subscriptionstatus: 'paid' });
                } else {
                  this._runCode('free', reading);
                  this.setState({ subscriptionstatus: 'free' });
                }
              } else {
                console.log('fail');
              }
            },
          );
        }
      }
    });
  };
  _runCode(subscriptionstatus, reading) {
    var data = {
      token: this.state.token,
      idname: this.state.idname,
      reading_id: reading.id,
      chapter_id: this.state.chapterid,
      offset: 0,
      limit: 1,
      subscriptionstatus: subscriptionstatus,
    };

    FD.callAPI(App_data.backend_api + '/soa_p_question_bank/getQuestions', data).then(resp => {
      if (resp.success) {
        if (resp.questions.length) {
          this.context.router.push({
            pathname: `/soa/probability/viewquestions/${reading.id}/${reading.chapter_no}/${
              reading.reading
            }/${this.state.chapterid}/${this.state.subscriptionstatus}`,
            state: {
              token: this.state.token,
              idname: this.state.idname,
              reading: reading,
              chapter: this.state.chapterid,
              subscriptionstatus: this.state.subscriptionstatus,
            },
          });
        } else {
          this.toggleAlert();
        }
      }
    });
  }

  //Function to redirect page on specifc questions
  _beginChapter = (reading, e) => {
    var data = {
      token: this.state.token,
      idname: this.state.idname,
      reading_id: reading.id,
      chapter_id: this.state.chapterid,
      offset: 0,
      limit: 1,
      subscriptionstatus: this.state.subscriptionstatus,
    };
    // console.log(data);

    FD.callAPI(App_data.backend_api + '/soa_p_question_bank/getQuestions', data).then(resp => {
      if (resp.success) {
        if (resp.questions.length) {
          // console.log(resp.questions);
          this.context.router.push({
            pathname:
              '/soa/probability/beginchapter/' +
              this.state.chapterid +
              '/' +
              reading.id +
              '/' +
              resp.questions[0].id +
              '/' +
              0,
            state: {
              token: this.state.token,
              idname: this.state.idname,
              reading: reading,
              chapter: this.props.params.chapter,
              offset: 0,
            },
          });
        } else {
          this.toggleAlert();
        }
      }
    });
  };
  /*
------------------------------
  PDF DOWNLOAD  Question Via Email
-------------------------------
*/
  getpdf = async e => {
    console.log('getpdf');
    if (this.state.pdfLoading == false) {
      alert('Download is in progress....');
      return;
    }
    if (this.state.pdfLoadingAnswer == false) {
      alert('Please wait one process is in queue.');
      return;
    }

    var data = { token: this.state.token, idname: this.state.idname };
    await FD.callAPI(App_data.backend_api + '/user/getProfileInfo', data).then(async resp => {
      if (resp.profileInfo.role === 'partner') {
        if (resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '') {
          this.PDFToggleAlert();
        } else {
          var data_arr = resp.profileInfo.exam_selected
            ? JSON.parse(resp.profileInfo.exam_selected)
            : null;
          var dataset = {
            token: this.state.token,
            idname: this.state.idname,
            examid: data_arr,
          };
          await FD.callAPI(App_data.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(
            async resp_exam => {
              if (resp_exam.success) {
                var exam_data = resp_exam.examData;
                var selectedmen = this.state.selectedmenu;
                var isInArray_var = false;

                isInArray_var = await PartnerSoaP_SubscriptionCheck.checkSoaP_PDFSubscription(
                  selectedmen,
                  exam_data,
                  this.state.type,
                );
                if (isInArray_var) {
                  this.setState({
                    pdfLoading: false,
                  });
                  // const result = getDeviceDetails();
                  var dataset = {
                    token: this.state.token,
                    idname: this.state.idname,
                    chapterId: this.state.chapterid,
                    city: this.state.user_city,
                    country: this.state.user_country,
                    state: this.state.user_state,
                    continent: this.state.user_continent,
                    ip: this.state.user_ip,
                  };
                  await FD.callAPI(
                    App_data.backend_api + '/soa_p_question_bank/Q-PdfDownloadViaEmail',
                    dataset,
                  ).then(response => {
                    if (response.success) {
                      this.setState({
                        pdfLoading: true,
                        PDFDownloadType: 'Question',
                      });
                      this.pdfAlertModel();
                    } else if (!response.pdf) {
                      this.setState({
                        pdfLoading: true,
                        PDFDownloadType: 'Question',
                      });
                      this.pdfAlertModel();
                    }
                  });
                } else {
                  this.PDFToggleAlert();
                }
              } else {
                // console.log('fail');
              }
            },
          );
        }
      } else {
        if (resp.profileInfo.exam_selected === '') {
          this.PDFToggleAlert();
        } else {
          var data_arr = resp.profileInfo.exam_selected
            ? JSON.parse(resp.profileInfo.exam_selected)
            : null;
          var dataset = {
            token: this.state.token,
            idname: this.state.idname,
            examid: data_arr,
          };
          await FD.callAPI(App_data.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(
            async resp_exam => {
              if (resp_exam.success) {
                var exam_data = resp_exam.examData;
                var selectedmen = this.state.selectedmenu;
                var isInArray_var = false;

                isInArray_var = await SoaP_SubscriptionCheck.checkSoaP_PDFSubscription(
                  selectedmen,
                  exam_data,
                  this.state.type,
                );
                if (isInArray_var) {
                  this.setState({
                    pdfLoading: false,
                  });
                  // const result = getDeviceDetails();
                  var dataset = {
                    token: this.state.token,
                    idname: this.state.idname,
                    chapterId: this.state.chapterid,
                    city: this.state.user_city,
                    country: this.state.user_country,
                    state: this.state.user_state,
                    continent: this.state.user_continent,
                    ip: this.state.user_ip,
                  };
                  await FD.callAPI(
                    App_data.backend_api + '/soa_p_question_bank/Q-PdfDownloadViaEmail',
                    dataset,
                  ).then(response => {
                    if (response.success) {
                      this.setState({
                        pdfLoading: true,
                        PDFDownloadType: 'Question',
                      });
                      this.pdfAlertModel();
                    } else if (!response.pdf) {
                      this.setState({
                        pdfLoading: true,
                        PDFDownloadType: 'Question',
                      });
                      this.pdfAlertModel();
                    }
                  });
                } else {
                  this.PDFToggleAlert();
                }
              } else {
                // console.log('fail');
              }
            },
          );
        }
      }
    });
  };

  /*
------------------------------
  PDF DOWNLOAD  Question/Answer
-------------------------------
*/
  getpdfAnswer = async e => {
    console.log('getpdfAnswer');

    if (this.state.pdfLoadingAnswer == false) {
      alert('Download is in progress....');
      return;
    }
    if (this.state.pdfLoading == false) {
      alert('Please wait one process is in queue.');
      return;
    }

    var data = { token: this.state.token, idname: this.state.idname };
    FD.callAPI(App_data.backend_api + '/user/getProfileInfo', data).then(async resp => {
      if (resp.profileInfo.role === 'partner') {
        if (resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '') {
          this.PDFToggleAlert();
        } else {
          var data_arr = resp.profileInfo.exam_selected
            ? JSON.parse(resp.profileInfo.exam_selected)
            : null;
          var dataset = {
            token: this.state.token,
            idname: this.state.idname,
            examid: data_arr,
          };
          await FD.callAPI(App_data.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(
            async resp_exam => {
              if (resp_exam.success) {
                var exam_data = resp_exam.examData;
                var selectedmen = this.state.selectedmenu;
                var isInArray_var = false;
                isInArray_var = await PartnerSoaP_SubscriptionCheck.checkSoaP_PDFSubscription(
                  selectedmen,
                  exam_data,
                  this.state.type,
                );
                if (isInArray_var) {
                  this.setState({
                    pdfLoadingAnswer: false,
                  });
                  // const result = getDeviceDetails();

                  var dataset = {
                    token: this.state.token,
                    idname: this.state.idname,
                    chapterId: this.state.chapterid,
                    city: this.state.user_city,
                    country: this.state.user_country,
                    state: this.state.user_state,
                    continent: this.state.user_continent,
                    ip: this.state.user_ip,
                  };
                  await FD.callAPI(
                    App_data.backend_api + '/soa_p_question_bank/QA-PdfDownloadViaEmail',
                    dataset,
                  ).then(response => {
                    if (response.success) {
                      this.setState({
                        pdfLoadingAnswer: true,
                        PDFDownloadType: 'Question/Answer',
                      });
                      this.pdfAlertModel();
                    } else if (!response.pdf) {
                      this.setState({
                        pdfLoadingAnswer: true,
                        PDFDownloadType: 'Question/Answer',
                      });
                      this.pdfAlertModel();
                    }
                  });
                } else {
                  this.PDFToggleAlert();
                }
              } else {
                // console.log('fail');
              }
            },
          );
        }
      } else {
        if (resp.profileInfo.exam_selected === '') {
          this.PDFToggleAlert();
        } else {
          var data_arr = resp.profileInfo.exam_selected
            ? JSON.parse(resp.profileInfo.exam_selected)
            : null;
          var dataset = {
            token: this.state.token,
            idname: this.state.idname,
            examid: data_arr,
          };
          await FD.callAPI(App_data.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(
            async resp_exam => {
              if (resp_exam.success) {
                var exam_data = resp_exam.examData;
                var selectedmen = this.state.selectedmenu;
                var isInArray_var = false;
                isInArray_var = await SoaP_SubscriptionCheck.checkSoaP_PDFSubscription(
                  selectedmen,
                  exam_data,
                  this.state.type,
                );
                if (isInArray_var) {
                  this.setState({
                    pdfLoadingAnswer: false,
                  });
                  // const result = getDeviceDetails();

                  var dataset = {
                    token: this.state.token,
                    idname: this.state.idname,
                    chapterId: this.state.chapterid,
                    city: this.state.user_city,
                    country: this.state.user_country,
                    state: this.state.user_state,
                    continent: this.state.user_continent,
                    ip: this.state.user_ip,
                  };
                  await FD.callAPI(
                    App_data.backend_api + '/soa_p_question_bank/QA-PdfDownloadViaEmail',
                    dataset,
                  ).then(response => {
                    if (response.success) {
                      this.setState({
                        pdfLoadingAnswer: true,
                        PDFDownloadType: 'Question/Answer',
                      });
                      this.pdfAlertModel();
                    } else if (!response.pdf) {
                      this.setState({
                        pdfLoadingAnswer: true,
                        PDFDownloadType: 'Question/Answer',
                      });
                      this.pdfAlertModel();
                    }
                  });
                } else {
                  this.PDFToggleAlert();
                }
              } else {
                // console.log('fail');
              }
            },
          );
        }
      }
    });
  };
  goPremium() {
    this.context.router.push({
      pathname: '/Subscribe/',
      state: {
        token: this.state.token,
        idname: this.state.idname,
        selectedMenu: this.state.selectedmenu,
      },
    });
  }
  render() {
    let readings = this.state.readings;
    let data = '';

    if (this.state.readings.length) {
      data = readings.map((item, index) => (
        <tr key={index}>
          <td>{item.order_no}.</td>
          <td>{item.reading}</td>
          <td>
            <span className='tooltip_wrap margin_right_20'>
              <img
                src={App_data.frontend_url + '/img/question_bank/eye_icon.svg'}
                className='pointer_class'
                alt=''
                width='23'
                onClick={this._getQuestions.bind(this, item)}
                id={item.id}
                title=''
              />
              <div className='tootip_box'>{language.LC().VIEW_LIST}</div>
            </span>

            <span className='tooltip_wrap'>
              <img
                src={App_data.frontend_url + '/img/question_bank/open_book_icon.svg'}
                className='pointer_class'
                alt=''
                width='21'
                id={item.id}
                onClick={this._beginChapter.bind(this, item)}
                title=''
              />
              <div className='tootip_box'>{language.LC().BEGIN_CHAPTER}</div>
            </span>
          </td>
        </tr>
      ));
    } else {
      data = (
        <div className='loader_box'>
          <div className='sk-circle'>
            <div className='sk-circle1 sk-child' />
            <div className='sk-circle2 sk-child' />
            <div className='sk-circle3 sk-child' />
            <div className='sk-circle4 sk-child' />
            <div className='sk-circle5 sk-child' />
            <div className='sk-circle6 sk-child' />
            <div className='sk-circle7 sk-child' />
            <div className='sk-circle8 sk-child' />
            <div className='sk-circle9 sk-child' />
            <div className='sk-circle10 sk-child' />
            <div className='sk-circle11 sk-child' />
            <div className='sk-circle12 sk-child' />
          </div>
        </div>
      );
    }

    return (
      <div>
        <div className='animated fadeIn'>
          <div className='row'>
            <div className='col-md-8 margin_bottom_20'>
              <h1 className='section_head'>{this.state.chapterName}</h1>
            </div>
            <div className='col-md-4 text-md-right margin_bottom_20 question-download-reading-page'>
              <span
                onClick={this.getpdf.bind(this)}
                className='status-download-btn margin_right_10'
              >
                <a className='btn btn-primary  pointer_class pull-right'>
                  {this.state.pdfLoading ? (
                    <i className='fa fa-download' aria-hidden='true' />
                  ) : (
                    <i className='fa fa-spinner fa-spin' aria-hidden='true' />
                  )}
                  {this.state.showFreePremium ? (
                    <div className='premium-download'>{language.LC().PREMIUM}</div>
                  ) : null}
                  {this.state.pdfLoading ? language.LC().Download_Question : '  please wait...'}
                </a>
              </span>
              <span
                onClick={this.getpdfAnswer.bind(this)}
                className='status-download-btn margin_right_10'
              >
                <a className='btn btn-primary  pointer_class pull-right'>
                  {this.state.pdfLoadingAnswer ? (
                    <i className='fa fa-download' aria-hidden='true' />
                  ) : (
                    <i className='fa fa-spinner fa-spin' aria-hidden='true' />
                  )}
                  {this.state.showFreePremium ? (
                    <div className='premium-download'>{language.LC().PREMIUM}</div>
                  ) : null}
                  {this.state.pdfLoadingAnswer
                    ? language.LC().Download_Question_Answer
                    : '  please wait...'}
                </a>
              </span>
              <button
                type='button'
                className='btn btn-primary pointer_class'
                onClick={this._getChapters}
              >
                {' '}
                {language.LC().CHANGE_TOPIC}{' '}
              </button>
            </div>
          </div>

          <div className='row'>
            <div className='col-md-12'>
              <div className='card height_70vh'>
                <div className='card-header'>{/* {language.LC().CHAPTER_READINGS} */}</div>

                <div className='table_responsive_wrapper'>
                  <div className='table-responsive reading-table-wrap'>
                    <table className='table_white_bg table '>
                      <thead>
                        <tr className='border_top_0'>
                          <th width='90'>#</th>
                          <th>{language.LC().READING}</th>
                          <th width='130'>{language.LC().ACTION}</th>
                        </tr>
                      </thead>
                      <tbody>{data}</tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Modal
          isOpen={this.state.alert_status}
          toggle={this.toggleAlert}
          className={'modal-primary ' + this.props.className}
        >
          <ModalHeader toggle={this.toggleAlert}>{this.state.MessageTitle}</ModalHeader>
          <ModalBody className='d-flex justify-content-between align-items-center'>
            {this.state.MessageContent}
            <Button color='primary' onClick={this.toggleAlert}>
              {' '}
              {language.LC().OK}{' '}
            </Button>
          </ModalBody>
        </Modal>

        <ModalComponent
          goPremium={this.goPremium.bind(this)}
          toggleAlert={this.PDFToggleAlert.bind(this)}
          alert_status={this.state.PDF_Alert_status}
          MessageContent={this.state.PDFMessageContent}
          exam={examNameAccordingToDB.SOA_P}
        />
        <PDFModelComponent
          type={this.state.PDFDownloadType}
          pdfAlertModel={this.pdfAlertModel.bind(this)}
          pdfAlert={this.state.PDFDownloadAlertStatus}
          PDFContentMessage={this.state.PDFContentMessage}
        />
      </div>
    );
  }
}

export default SOA_P_Readings;



// WEBPACK FOOTER //
// ./src/views/SOA/Probability/Readings/Readings.js